import { useEffect, useRef } from "react"
import { Marker, Tooltip, Popup } from "react-leaflet"
import MarkerTooltip from "./MarkerTooltip"
import styles from "../Dashboard.module.css"

const MapMarker = ({ location, handlePopupOpen, handlePopupClose, showMarkerTooltip, isActive }) => {
  const markerRef = useRef(null)

  useEffect(() => {
    if (!markerRef.current) return;

    if (isActive) {
      markerRef.current.openPopup();
    }
  }, [isActive]);

  return (
    <Marker
      position={location.position}
      icon={location.icon}
      ref={markerRef}
      eventHandlers={{
        popupopen: () => handlePopupOpen(location.id),
        popupclose: () => handlePopupClose(location.id),
      }}
    >
      <Tooltip
        permanent={showMarkerTooltip}
        direction="right"
        offset={[20, -28]}
        opacity={1}
        className={`${styles.customTooltip} ${styles.noArrowTooltip}`}
      >
        <MarkerTooltip
          location={location}
          onClick={(e) => {
            e.stopPropagation()

            if (!markerRef.current) return

            if (markerRef.current.isPopupOpen()) {
              markerRef.current.closePopup()
            } else {
              markerRef.current.openPopup()
            }
          }}
        />
      </Tooltip>

      <Popup offset={[3, -53]}>
        {location.popupBody()}
      </Popup>
    </Marker>
  )
}

export default MapMarker